export default {
  getLabel: (entityName, records) => {
    let totalLength = Array.isArray(records) ? records.length : records;
    if (totalLength <= 1) return "Search";
    return `Search ${totalLength} ${entityName}`;
  },
};
